export default __webpack_public_path__ + "static/2372-0c6a4f5dcabc0e6f933653191d2c3035.gif";